import React from 'react';
import { theme } from 'antd';
import { UserOutlined, HomeOutlined, ToolOutlined, CarOutlined } from '@ant-design/icons';
import { purple } from '@ant-design/colors';
import type { ResourceType } from '@/api/mcp-appointments';

/** Resource type icon component using theme tokens */
export function ResourceTypeIcon({
  type,
  style,
  neutral
}: {
  type: ResourceType;
  style?: React.CSSProperties;
  /** Inherit parent text color (e.g. calendar events on status backgrounds). */
  neutral?: boolean;
}) {
  const { token } = theme.useToken();
  const colorMap: Record<string, string> = {
    PERSON: token.colorPrimary,
    ROOM: token.colorSuccess,
    EQUIPMENT: token.colorWarning,
    VEHICLE: purple[5],
  };
  const color = neutral ? 'inherit' : (colorMap[type] ?? token.colorTextSecondary);
  const Icon = type === 'ROOM' ? HomeOutlined : type === 'EQUIPMENT' ? ToolOutlined : type === 'VEHICLE' ? CarOutlined : UserOutlined;
  return <Icon style={{ color, ...style }} />;
}
